import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useOverview } from "@app/api/overview";
import { KpiCard } from "@app/components/KpiCard";
import { ErrorMessage, Loading } from "@app/components/Feedback";

export default function OverviewPage() {
  const { data, isLoading, error } = useOverview();

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Overview
      </Typography>

      {isLoading && <Loading />}
      {error && <ErrorMessage error={error} />}

      {data && (
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" }
          }}
        >
          <KpiCard label="Users" value={data.users} hint={`${data.usersEnabled} enabled`} />
          <KpiCard label="New users (7d)" value={data.usersLast7d} hint={`${data.usersLast30d} in 30d`} />
          <KpiCard label="Organizations" value={data.organizations} />
          <KpiCard
            label="Games"
            value={data.games}
            hint={`${data.gamesPublished} published · ${data.gamesDraft} draft · ${data.gamesArchived} archived`}
          />
          <KpiCard label="New games (7d)" value={data.gamesLast7d} hint={`${data.gamesLast30d} in 30d`} />
          <KpiCard
            label="Sessions"
            value={data.sessions}
            hint={`${data.sessionsCompleted} completed`}
          />
          <KpiCard label="Sessions (7d)" value={data.sessionsLast7d} hint={`${data.sessionsLast30d} in 30d`} />
        </Box>
      )}
    </Box>
  );
}
